// What an uploaded folder contained (DEC-180, UI_SDD §4.1). Rendered beside the scan mode
// banner wherever that banner is, so a report of an upload always says what was examined
// and what was left out (§0.6). Renders nothing for clone and server-path scans.

import { useQuery } from '@tanstack/react-query'
import { FolderUp } from 'lucide-react'
import { scansApi } from '../api/scans'
import type { UploadSourceManifest } from '../types/api'
import { sourceManifestSentence } from '../utils/folderUpload'

export function SourceManifestNote({ manifest }: { manifest?: UploadSourceManifest | null }) {
  if (!manifest || manifest.kind !== 'upload') return null
  return (
    <p className="flex items-start gap-1.5 text-[12px] leading-[1.55] text-muted mb-3" data-testid="source-manifest">
      <FolderUp className="mt-[2px] h-[13px] w-[13px] flex-none" />
      <span>
        {sourceManifestSentence(manifest)}
        {!manifest.has_git_history && '. Code age and ownership were not measured.'}
      </span>
    </p>
  )
}

/** For pages that hold the report rather than the scan: fetches the scan's manifest. */
export function ScanSourceManifestNote({ scanId }: { scanId?: string }) {
  const { data } = useQuery({
    queryKey: ['scan-source-manifest', scanId],
    queryFn: () => scansApi.get(scanId!),
    enabled: !!scanId,
    retry: false,
    staleTime: Infinity,
  })
  return <SourceManifestNote manifest={data?.source_manifest} />
}
